export const openx_config = {
    'all': {
        delDomain: 'readtheory-d.openx.net',
    },

    'efe_hp_728': {
        unit: '540803666',
    },

    'efe_topics_160': {
        unit: '540803667',
    },

    'efe_topics_bottom_728': {
        unit: '540803668',
    },

    'efe_topics_mid_728_1': {
        unit: '540803669',
    },
    'efe_topics_mid_728_2': {
        unit: '540803670'
    },
    'efe_topics_mid_728_3': {
        unit: '540803671'
    },
    'efe_300_mid': {
        unit: '540816400'
    },
    'EFE_PDF_Top': {
        unit: '540926013',
    },
    'EFE_PDF_Bottom': {
        unit: '540926014',
    },
    'EFE_Right_Sticky': {
        unit: '540926017',
    },


};
